import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyD9omD22fcqBzB0S99wU_FEfMl01fXNVAQ",
  authDomain: "grade-3d350.firebaseapp.com",
  projectId: "grade-3d350",
  storageBucket: "grade-3d350.firebasestorage.app",
  messagingSenderId: "791029557929",
  appId: "1:791029557929:web:41fd087efddefe702b17b8",
  measurementId: "G-NC6Z5MJ36K"
};

const app = initializeApp(firebaseConfig);
export { app as firebaseApp };
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
